<div [style.display]="isVisible() ? 'block' : 'none'" class="approval-item-wrapper">
  <div [id]="htmlId()" class="approval-wrapper">
    <div class="approval-text preserve-newlines">{{ properties.text }}</div>

    @if (properties.groupItems.length && !hasValue()) {
      <div class="approval-user-role">{{ properties.groupItems.join(' / ') }}</div>
    }

    <div class="approval-action-wrapper">
      @if (!hasValue()) {
        <button
          type="button"
          class="approval-opener"
          [class.approval-actioned]="isAccepted()"
          [class.approval-not-actioned]="isRejected()"
          (click)="onAcceptClick()"
          [disabled]="hasValue() || !canSign() || formControl?.disabled">
          <div class="icon-safe-zone">
            <mat-icon class="icon icon-positive">check</mat-icon>
          </div>
          <span>{{ properties.acceptCaption }}</span>
        </button>

        <button
          type="button"
          class="approval-opener"
          [class.approval-actioned]="isRejected()"
          [class.approval-not-actioned]="isAccepted()"
          (click)="onRejectClick()"
          [disabled]="hasValue() || !canSign() || formControl?.disabled">
          <div class="icon-safe-zone">
            <mat-icon class="icon icon-negative">block</mat-icon>
          </div>
          <span>{{ properties.rejectCaption }}</span>
        </button>
      }
      @if (hasValue()) {
        <button class="control" type="button" (click)="resetSignature()" [disabled]="formControl?.disabled">
          <div class="icon-safe-zone">
            <mat-icon>delete</mat-icon>
          </div>
        </button>
      }
      @if (hasValue()) {
        <div class="approval-user">{{ signatureInfo() }}</div>
      }
    </div>
  </div>
</div>
